<template lang="pug">
.page-campaign-edit
 .page-header
    IQToolMiddlePaneHeader.header(:header="$t(`${baseTranslationPath}.title`)"
                           :title="pageTitle"
                           @goToListPage="back"
                           )

 .edit-area
    .field-container.full-width.is-required
      label {{  $t(`${baseTranslationPath}.name`) }}
      aiq-input(v-model="record.name"
                :disabled="viewMode"
                :min-length="250")

    .stages
      .title
        h3.stage-title {{ $t(`${baseTranslationPath}.stages`) }}
        .add-section
          aiq-button(type="primary" :disabled="viewMode" @click="showModal = true") {{ $t(`${baseTranslationPath}.add_existing_stage`) }}

    .field-group
      .group-item(v-for="(stage, index) in record.payload.stages" :key="stage.key")
        .group-name
          .position-action
            aiq-button(class="group-btn" :disabled="viewMode || disableUp(stage, index)" @click="moveAction(index, 'up')") {{ $t(`${baseTranslationPath}.previous`) }}
            aiq-button(class="group-btn" :disabled="viewMode || disableDown(stage, index)" @click="moveAction(index, 'down')") {{ $t(`${baseTranslationPath}.next`) }}
        .field-container.is-required.stage-field
          label {{ $t(`${baseTranslationPath}.stage_name`) }}
          aiq-input(v-model="stage.name"
                    :disabled="viewMode || stage.immutable"
                    :min-length="250")

        .field-container.stage-field
          label {{ $t(`${baseTranslationPath}.min_assignee_count`) }}
          aiq-input(v-model="stage.min_assignee_count"
                    :disabled="viewMode || stage.immutable"
                    type="number"
                    min="1")

        .field-container.stage-field
          label {{ $t(`${baseTranslationPath}.select_agent_team`) }}
            aiq-select(v-model="stage.default_assignees"
                        :disabled="viewMode || stage.immutable"
                        :max-length="250"
                        value-key="id"
                        multiple
                        :reserve-keyword="false")
                aiq-option(v-for="item in agentsAndTeams", :key="item.id", :label="item.name", :value="item")

        .field-container.stage-field
          aiq-button(type="primary"
                   :disabled="viewMode"
                   @click="addItem('new')") {{ $t(`${baseTranslationPath}.add_stage`) }}

          aiq-button(type="danger"
                     v-if="showRemoveStageButton"
                     class="group-btn"
                     :disabled="viewMode"
                     @click="removeStage(index)") {{ $t(`${baseTranslationPath}.remove_stage`) }}
    .footer
      aiq-button(v-if="!viewMode && !isNew" type="danger" :plain="true" @click="deleteRule") {{ $t('global.delete') }}
      aiq-button(@click="back()") {{ viewMode ? $t('global.close') : $t('global.cancel') }}
      aiq-button(v-if="!viewMode" class="save-btn required" :disabled="!isSubmittable" type="primary" @click="saveRule") {{ $t('global.save') }}

.select-existing
  aiq-dialog.modal-editor(:title="$t(`${baseTranslationPath}.select_existing`)"
            v-model="showModal"
            :show-close="true"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
             @close="closeModal")
    .field-container.full-width.is-required
      label {{  $t(`${baseTranslationPath}.exiting_stages`) }}
      aiq-select(v-model="selectedExistingStages"
        :disabled="viewMode"
        :suffix-icon="Icon.CaretBottom"
        multiple
        )
        aiq-option(v-for="stage in exisitingStages" :key="stage.name" :label="stage.name" :value="stage.name")
    .footer-dialog
      aiq-button(@click="closeModal") {{ $t('global.close') }}
      aiq-button(class="save-btn required" :disabled="selectedExistingStages.length === 0" type="primary" @click="saveStages") {{ $t('global.save') }}

</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { AGENT_LIMIT, TEAM_LIMIT } from '@/constants/pagination';

const DEFAULT_RULE = {
  name: '',
  payload: {
    stages: [{
      name: '',
      min_assignee_count: 1,
      default_assignees: [],
      immutable: false,
      key: 0,
    }],
  },
};

export default {
  name: 'ManageRule',
  components: { IQToolMiddlePaneHeader },
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.rules_manage.manage',
      viewMode: false,
      isNew: false,
      showModal: false,
      selectedExistingStages: [],
      agentsAndTeams: [],
      exisitingStages: [],
      record: { ...DEFAULT_RULE },
      cloneStages: [],
    };
  },
  computed: {
    pageTitle() {
      if (this.viewMode) {
        return this.$t(`${this.baseTranslationPath}.view`);
      }
      if (this.isNew) {
        return this.$t(`${this.baseTranslationPath}.new`);
      }
      return this.$t(`${this.baseTranslationPath}.edit`);
    },
    isSubmittable() {
      if (this.record.name === '') {
        return false;
      }

      return this.validateRule();
    },
    showRemoveStageButton() {
      return get(this.record, 'payload.stages', []).length > 1;
    },
  },
  async mounted() {
    await this.init();
    await this.fetchStages();
    await this.getAgentsAndTeams();

    this.cloneStages = cloneDeep(this.record.payload.stages);
  },
  methods: {
    async init() {
      const params = get(this.$route, 'params.id', '');
      this.viewMode = JSON.parse(get(this.$route, 'query.view', false));
      this.isNew = params === 'new';

      if (!this.isNew) {
        const rule = await this.$store.dispatch('smartControl/getRule', params);
        this.record = rule.data;
        //append key
        this.record.payload.stages = this.record.payload.stages.map((stage, index) => {
          return {
            ...stage,
            key: index,
          };
        });
      } else {
        this.record = {
          name: '',
          payload: {
            stages: [{
              name: '',
              min_assignee_count: 1,
              default_assignees: [],
              immutable: false,
              key: 0,
            }],
          },
        };
      }
    },
    async fetchStages() {
      const stages = await this.$store.dispatch('smartControl/fetchStages');
      const existingStages = get(stages, 'data.models', []);
      this.exisitingStages = existingStages.filter(stage => stage.name.trim() !== '').map(stage => {
        return {
          name: stage.name,
          min_assignee_count: 1,

        }; });
    },
    async getAgentsAndTeams() {
      const agents = await this.$store.dispatch('agents/getAgentsList',
        [{limit: AGENT_LIMIT}, true],
      );
      const agent_data = get(agents, 'data.models', []);

      const agentSelectable = agent_data.map((agent) => {
        return {
          id: agent.id,
          name: agent.fullName,
          type: 'agent',
        };
      });
      const teams = await this.$store.dispatch('teams/getTeamsList', [{ limit: TEAM_LIMIT }]);
      const team_data = get(teams, 'data.models', []);
      const teamSelectable = team_data.map((team) => {
        return {
          id: team.id,
          name: team.name,
          type: 'team',
        };
      });
      this.agentsAndTeams = [...agentSelectable, ...teamSelectable];
    },
    back() {
      const currentPath = this.$route.path;
      const parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'));
      // get parant name if exist
      const name = get(this.$route, 'meta.parentName');
      // move to the parent
      this.$router.push(name ? { name } : parentPath);
    },
    async deleteConfirm() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.baseTranslationPath}.delete_confirm.title`),
          this.$t(`${this.baseTranslationPath}.delete_confirm.message`),
        );
        return true;
      } catch {
        return false;
      }
    },
    async deleteRule() {
      const response = await this.deleteConfirm();
      try {
        if (response) {
          await this.$store.dispatch('smartControl/deleteRule', this.record.id);
          this.$aiq.notify.success('Rule deleted successfully');
          this.back();
        }
      } catch (error) {
        const err = get(error, 'response.data.message', 'Error deleting rule');
        this.$aiq.notify.error(err);
      }
    },
    validateRule() {
      //validate that at least one stage exist
      const stages = get(this.record, 'payload.stages', []);
      if (isEmpty(stages)) {
        return false;
      }
      //validate that all names and min_assignee_count are not empty
      const invalidStages = stages.filter(stage => stage.name === '' || stage.min_assignee_count === '');

      if (!isEmpty(invalidStages)) {
        return false;
      }
      //check if duplicate stages name exist
      const stageNames = this.record.payload.stages.map(stage => stage.name.trim().toLocaleLowerCase());
      const uniqueStageNames = new Set(stageNames);
      if (stageNames.length !== uniqueStageNames.size) {
        return false;
      }

      return true;
    },


    compareStagesData() {
      const stagesWithoutDefaultAssignees = this.record.payload.stages.map(stage => {
        return {
          name: stage.name,
          min_assignee_count: stage.min_assignee_count,
          stage_id: stage.stage_id,
        };
      });

      const stagesFromClone = this.cloneStages.map(stage => {
        return {
          name: stage.name,
          min_assignee_count: stage.min_assignee_count,
          stage_id: stage.stage_id,
        };
      });

      return isEqual(stagesWithoutDefaultAssignees, stagesFromClone);
    },

    async fetchUpdateWarning() {
      try {
        //only show warning when there is a change to stage min assignee count or name
        if (this.compareStagesData()) {
          return true;
        }

        const response = await this.$store.dispatch('smartControl/getRuleDocuments', this.record.id);
        const message = get(response, 'data.models', []);
        if (isEmpty(message)) {
          return true;
        }
        const messageHeader = this.$t(`${this.baseTranslationPath}.affected_docs`);
        const messageBody = message.map(doc => `<b>${doc.name}</b>`).join(',<br>');
        const messageContent = `${messageHeader}: <br><br>${messageBody}`;

        await this.$aiq.confirm(
          this.$t(`${this.baseTranslationPath}.continue`),
          messageContent,
        );
        return true;
      } catch {
        return false;
      }

    },
    async saveRule() {
      try {
        const payload = {
          name: this.record.name,
          stages: this.record.payload.stages,
        };

        payload.stages = payload.stages.map((stage) => {
          return {
            name: stage.name,
            min_assignee_count: parseInt(stage.min_assignee_count),
            default_assignees: stage.default_assignees,
          };
        });
        if (this.isNew) {
          await this.$store.dispatch('smartControl/createRule', payload);
          this.$aiq.notify.success('Rule created successfully');
          this.back();
        } else {
          const response = await this.fetchUpdateWarning();
          if (!response) {
            return;
          }
          const rule = {
            id: this.record.id,
            data: payload,
          };
          await this.$store.dispatch('smartControl/updateRule', rule);
          this.$aiq.notify.success('Rule updated successfully');
          this.back();
        }
      } catch (error) {
        this.$aiq.notify.error('Error saving rule');
      }

    },

    removeRedundantStage() {
      if (this.record.payload.stages.length === 1 && this.record.payload.stages[0].name === '') {
        this.record.payload.stages = [];
      }
    },

    saveStages() {
      this.showModal = false;
      this.removeRedundantStage();
      this.selectedExistingStages.forEach(stage => {
        const foundStage = this.exisitingStages.find(x => x.name === stage);
        if (foundStage) {
          //push to the bottom
          this.record.payload.stages.push({
            name: foundStage.name,
            immutable: false,
            key: this.record.payload.stages.length,
            min_assignee_count: foundStage.min_assignee_count,
          });
        }
      });

      this.selectedExistingStages = [];
    },
    disableDown(_, index) {
      //disable if it is the last item
      return index === this.record.payload.stages.length - 1;
    },
    disableUp(_, index) {
      //disable if it is the first item
      return index === 0;
    },

    moveAction(index, action) {
      if (action === 'up') {
        this.record.payload.stages.splice(index - 1, 0, this.record.payload.stages.splice(index, 1)[0]);
      } else {
        this.record.payload.stages.splice(index + 1, 0, this.record.payload.stages.splice(index, 1)[0]);
      }

    },
    removeStage(index) {
      this.record.payload.stages.splice(index, 1);
    },
    addItem(type) {
      if (type === 'existing') {
        this.showModal = true;
      } else {
        //push to the bottom
        this.record.payload.stages.push({
          name: '',
          immutable: false,
          key: this.record.payload.stages.length,
          min_assignee_count: 1,
        });
      }
    },
    closeModal() {
      this.showModal = false;
      this.selectedExistingStages = [];
    },

  },
};
</script>
<style lang="scss" scoped>
.page-campaign-edit {
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 100px;
}
.page-header {
    display: flex;
    padding-top: 20px;
    height: 120px;
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.add-section {
  padding-right: 10px;
  padding-left: 10px;
}

.box {
  border: 1px solid black;
  padding: 0px;
  margin-bottom: 10px;
  right: 0;
  position: absolute;
  top: 55px;
  background-color: white;
  z-index: 1000;
}
.smartdrive-button {
  background-color: #fff;
}

.box ul li {
  line-height: 1.7;
  white-space: nowrap;
  cursor: pointer;
  padding:10px;
}

.smartdrive-option li:hover {
  background-color: #e1e4e7
}

.edit-area {
  padding-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
  border: 1px solid #A8A9AB;
  background-color: #f6f6f6;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}

.stages {
    padding-top: 20px
}

.stage-title {
    padding-top: 10px;
    padding-bottom: 10px;
}
.field-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
}

.footer-dialog {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
}

.group-name {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.group-item {
  flex: 0 0 30%;
  margin-right: 10px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border: 1px solid #A8A9AB;
  background-color: #eef1f6;
}

.stage-field {
    margin-top: 10px;
    margin-bottom: 10px;
}

:deep(.el-button.create) {
    align-self: baseline;
    padding: 4px 0;
    margin-left: 12px;
    color: #8492A6;
    font-size: 20px;
    line-height: 20px;
    border: 0;
}
</style>